export default {
	api: "//server-env-ws3.eu-central-1.elasticbeanstalk.com/api/", // it is a mock
	scoringApi: "https://ipqualityscore.com/" // it is a mock
}
